import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, Clock, Star } from "lucide-react";
import { API } from "@/data/site";
import { Reveal, SectionHead, Accent } from "@/components/Reveal";

export const PackageCard = ({ pkg, testidPrefix = "destination-card" }) => (
  <article
    data-testid={`${testidPrefix}-${pkg.id}`}
    className="card-lift group relative shrink-0 w-[300px] sm:w-[340px] rounded-3xl overflow-hidden border border-white/10 snap-start"
  >
    <img
      src={pkg.image}
      alt={pkg.title}
      loading="lazy"
      className="w-full h-[420px] object-cover transition-transform duration-700 ease-out group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F14] via-[#0B0F14]/25 to-transparent" />
    <div className="absolute top-4 left-4 pill-badge !py-1">
      <Star size={12} className="fill-[#F2C230] text-[#F2C230]" />
      {pkg.rating.toFixed(1)}
    </div>
    <div className="absolute inset-x-0 bottom-0 p-6">
      <p className="text-xs uppercase tracking-[0.2em] text-[#3FB6D3] font-semibold">{pkg.location}</p>
      <h3 className="font-sora text-lg font-bold mt-2 leading-snug">{pkg.title}</h3>
      <div className="flex items-center justify-between mt-3 text-sm">
        <span className="text-[#F2C230] font-bold">{pkg.price}<span className="text-[#F5F5F0]/50 font-normal"> / person</span></span>
        <span className="inline-flex items-center gap-1.5 text-[#F5F5F0]/60 text-xs">
          <Clock size={13} /> {pkg.duration}
        </span>
      </div>
    </div>
    <Link
      to={`/contact?package=${pkg.id}`}
      data-testid={`destination-book-button-${pkg.id}`}
      className="absolute inset-0 flex items-center justify-center bg-[#0B0F14]/60 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-400"
    >
      <span className="btn-gold">View Details <ArrowRight size={15} /></span>
    </Link>
  </article>
);

const Destinations = () => {
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/packages`, { params: { type: "india" } })
      .then((r) => setPackages(r.data.slice(0, 6)))
      .catch(() => {});
  }, []);

  return (
    <section className="py-24 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-wrap items-end justify-between gap-6 mb-12">
        <SectionHead
          eyebrow="Popular Right Now"
          title={<>Journeys people can't stop <Accent>talking</Accent> about</>}
        />
        <Reveal delay={0.1}>
          <Link to="/tours" data-testid="destinations-view-all" className="btn-outline !py-2.5 !px-5 text-sm">
            View all tours <ArrowRight size={15} />
          </Link>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <div
          data-testid="destinations-scroller"
          className="flex gap-6 overflow-x-auto hide-scrollbar snap-x snap-mandatory px-5 sm:px-8 pb-4 max-w-7xl mx-auto"
        >
          {packages.map((p) => (
            <PackageCard key={p.id} pkg={p} />
          ))}
        </div>
      </Reveal>
    </section>
  );
};

export default Destinations;
